"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import styled from "styled-components";
const SVG = styled.svg`
  min-width: ${({ $size }) => $size};
  max-width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
`;
const Delete = ({ size = "1em", color = "currentColor", title, ...props }) => /* @__PURE__ */ jsxs(SVG, { ...props, $size: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: title ? "img" : "presentation", children: [
  title ? /* @__PURE__ */ jsx("title", { children: title }) : null,
  " ",
  /* @__PURE__ */ jsx("path", { fill: color, d: "M8.923 4.875h-3.68a.752.752 0 0 0-.743.75c0 .417.333.75.744.75h13.512a.752.752 0 0 0 .744-.75.745.745 0 0 0-.744-.75h-3.68v-.812c0-.87-.694-1.563-1.552-1.563h-3.048c-.847 0-1.553.7-1.553 1.563v.812zm6.75 15.801l1.28-12.5a.769.769 0 0 1 .848-.672c.426.04.737.408.695.82l-1.28 12.5a.766.766 0 0 1-.771.676h-8.89a.766.766 0 0 1-.771-.676l-1.28-12.5a.757.757 0 0 1 .695-.82c.426-.041.806.26.848.672l1.28 12.5L7.555 20h8.89l-.772.676z", children: " " })
] });
var Delete_default = Delete;
export {
  Delete_default as default
};
